<template>
  <div class="kpt-remote-detail" v-if="remote && !isLoading">
    <vue-headful :title="title" />
    <header class="kpt-detail-pane-header" :class="{ 'kpt-detail-pane-header-pulse': isRefreshing }">
      <h4>
        <b-tooltip label="Refreshing..." v-if="isRefreshing">
          <font-awesome-icon :icon="['far', 'spinner-third']" spin />
        </b-tooltip>
        <font-awesome-icon :icon="['far', 'satellite-dish']" v-else />
        <span>{{remote.name}}</span>
      </h4>
      <div class="page-control block">
        <!-- <font-awesome-icon :icon="['far', 'thumbtack']" @click="pinToDash('remote', remote)" title="Pin to Dashboard" /> -->
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <div class="kpt-detail-main">
      <div class="kpt-detail-nav">
        <b-field>
          <b-tooltip label="Type in a term filter the menu items. Ex: modem" position="is-right" type="is-info">
            <b-input v-model="menuFilterTerm" type="text" size="is-small" placeholder="Filter remote menu..." />
          </b-tooltip>
        </b-field>
        <header v-if="isVisible('remoteOverview') || isVisible('remoteDevices') || isVisible('remoteSubscription')">
          <h6 class="is-uppercase"><strong>General</strong></h6>
        </header>
        <ul>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteOverview' }" 
          ref="remoteOverview" 
          active-class="is-active" 
          :keywords="['overview', 'hub', 'status', 'map', 'summary', 'general', 'cellular', 'satellite', 'account', 'usage']" 
          v-show="isVisible('remoteOverview')">
            <a>
              <font-awesome-icon :icon="['far', 'file-chart-line']" />
              <span>Overview</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteDevices' }" 
          ref="remoteDevices" 
          active-class="is-active" 
          :keywords="['devices', 'update', 'modem', 'antenna', 'buc', 'terminal', 'cell', 'cellular', 'router', 'iccid', 'imei']" 
          v-show="isVisible('remoteDevices')">
            <a>
              <font-awesome-icon :icon="['far', 'microchip']" />
              <span>Devices</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteSubscription' }" 
          ref="remoteSubscription" 
          active-class="is-active" 
          :keywords="['subscription', 'region', 'data', 'package', 'plan', 'history', 'billing']" 
          v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin')"
          v-show="isVisible('remoteSubscription')">
            <a>
              <font-awesome-icon :icon="['far', 'file-invoice-dollar']" />
              <span>Subscriptions</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteUsage' }" 
          ref="remoteUsage" 
          active-class="is-active" 
          :keywords="['usage', 'transfer', 'subscription', 'chart', 'graph']" 
          v-show="isVisible('remoteUsage')">
            <a>
              <font-awesome-icon :icon="['far', 'exchange-alt']" />
              <span>Usage</span>
            </a>
          </router-link>
        </ul>
        <header v-if="isVisible('remoteConfiguration')">
          <h6 class="is-uppercase"><strong>Settings</strong></h6>
        </header>
        <ul>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteConfiguration' }" 
          ref="remoteConfiguration" 
          active-class="is-active" 
          :keywords="['config', 'pause', 'private', 'unpause', 'provision', 'activate', 'deactivate', 'configuration', 'network', 'ip', 'hub']" 
          v-show="isVisible('remoteConfiguration')">
            <a>
              <font-awesome-icon :icon="['far', 'sliders-h']" />
              <span>Configuration</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'remoteNetwork' }" active-class="is-active" v-if="$hasRole('Super User,Kymeta Admin,Product Support')">
            <a>
              <font-awesome-icon :icon="['far', 'network-wired']" />
              <span>Network</span>
            </a>
          </router-link>
          <router-link tag="li" 
            :to="{ name: 'remoteGroups' }" 
            ref="remoteGroups" 
            active-class="is-active"
            :keywords="['groups', 'remote']"  
            v-show="isVisible('remoteGroups')"
            v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin,Credentialed')">
            <a>
              <font-awesome-icon :icon="['far', 'object-group']" />
              <span>Groups</span>
            </a>
          </router-link>
        </ul>
        <header v-if="isVisible('remoteMetrics')">
          <h6 class="is-uppercase"><strong>Monitoring</strong></h6>
        </header>
        <ul>
          <router-link 
          tag="li" 
          :to="{ name: 'remoteMetrics' }" 
          active-class="is-active" 
          ref="remoteMetrics"
          :keywords="['metrics', 'chart', 'graph', 'data']" 
          v-show="isVisible('remoteMetrics')">
            <a>
              <font-awesome-icon :icon="['far', 'chart-area']" />
              <span>Metrics</span>
            </a>
          </router-link>
          <!-- <router-link tag="li" :to="{ name: 'remoteReplay' }" active-class="is-active">
            <a>
              <font-awesome-icon :icon="['far', 'history']" />
              <span>Replay</span>
            </a>
          </router-link> -->
          <router-link 
          tag="li"
          :to="{ name: 'remoteActivity' }" 
          active-class="is-active"
          ref="remoteActivity"
          :keywords="['activity', 'event', 'history']" 
          v-show="isVisible('remoteActivity')">
            <a>
              <font-awesome-icon :icon="['far', 'list-ul']" />
              <span>Activity</span>
            </a>
          </router-link>
        </ul>
        <!-- <header>
          <h6 class="is-uppercase"><strong>Support</strong></h6>
        </header>
        <ul>
          <router-link tag="li" :to="{ name: 'remoteSupport' }" active-class="is-active">
            <a>
              <font-awesome-icon :icon="['far', 'user-headset']" />
              <span>Contact Support</span>
            </a>
          </router-link>
        </ul> -->
      </div>
      <div class="kpt-detail-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <div v-else-if="!remote && !isLoading && notFound">
    <vue-headful title="Remote Not Found" />
    <header class="kpt-detail-pane-header">
      <h4>
        <span>Remote Not Found</span>
      </h4>
      <div class="page-control block">
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <div class="kpt-detail-main">
      <div class="kpt-detail-content" style="padding: 12px">
        <p>This remote does not exist or you don't have the permission to view this remote. If you've arrived here via a hotlink, please report this to Kymeta.</p>
        <br>
        <p>Go to the <a @click="close">remotes list</a> page.</p>
      </div>
    </div>
  </div>
  <div class="kpt-detail-loading" v-else>
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>
<script>
import { pinToDashMixin } from '../shared/mixins/pinToDash';

export default {
  data() {
    return {
      notFound: false,
      menuFilterTerm: ''
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id != from.params.id) {   
      this.$store.dispatch('fetchRemote', { id: to.params.id });
      this.$store.dispatch('fetchProviderNetworkRichState', { id: to.params.id });
    }
    next();
  },
  async created() {
    if (this.$route.params.id != 'create') {
      const result = await this.$store.dispatch('fetchRemote', { id: this.$route.params.id });
      if (!result) { 
        this.notFound = true;
      } else {
        await this.$store.dispatch('fetchProviderNetworkRichState', { id: this.remote.id }); 
      }
    }
  },
  mixins: [pinToDashMixin],
  computed: {
    remote() {
      return this.$store.state.remotes.remote;
    },
    isLoading() {
      return this.$store.state.remotes.remoteLoading;
    },
    isRefreshing() {
      return this.$store.state.remotes.remoteRefreshing;
    },
    title() {
      return `Remote - ${this.remote.name}`;
    },
    visibleMenuItems() {
      const inputValue = this.menuFilterTerm;
      const visibleArray = [];
      Object.keys(this.$refs).forEach((ref) => {
        const kw = this.$refs[ref].$el.getAttribute('keywords');
        const kwArray = kw.split(',');
        if (kwArray.includes(inputValue)) visibleArray.push(ref);
      });
      return visibleArray;
    }    
  },
  methods: {
    close() {
      this.$router.push({ path: '/remotes' });
    },
    isVisible(name) {
      return this.visibleMenuItems.includes(name) || !this.visibleMenuItems.length;
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-remote-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
